var map = {
	"./archive.png": 6969,
	"./delivery-truck.png": 6298,
	"./logo_dark_trans_fill_white.png": 4928,
	"./logo_trans.png": 8685,
	"./logo_trans_fill_white.png": 2839,
	"./logo_trans_white.png": 2771,
	"./logo_white_fill.png": 3706,
	"./logo_with_text_trans.png": 4294,
	"./logo_with_text_white_fill.png": 4471,
	"./upload.png": 2456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;